import { render, staticRenderFns } from "./projectParticipantsWidget.vue?vue&type=template&id=a89e61a0&scoped=true"
import script from "./projectParticipantsWidget.vue?vue&type=script&lang=js"
export * from "./projectParticipantsWidget.vue?vue&type=script&lang=js"
import style0 from "./projectParticipantsWidget.vue?vue&type=style&index=0&id=a89e61a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89e61a0",
  null
  
)

export default component.exports